import Icon from 'src/shared/icons'
import { VentasPorCategoria } from '../../ArticulosVendidos.type'
import './ResumenCategoria.css'
import { formatCurrencyToFixed } from 'src/shared/hooks/formatCurrency'


const ResumenCategoria = ({ ventas }: { ventas: VentasPorCategoria }) => {
    return (
        <div className='articulos-vendidos__card'>
            <span className='resumen-categoria__title'>Resumen por categoría</span>
            <div className="resumen-categoria__item">
                <div className="resumen-categoria__subitem">
                    <Icon name='dot' width={14} height={14} color='#F6BEC3' />
                    <span className="resumen-categoria__subitem__text">
                        Alimentos
                    </span>
                </div>
                <span className='resumen-categoria__subitem__amount'>{formatCurrencyToFixed(ventas?.alimentos || 0)}</span>
            </div>
            <div className="resumen-categoria__item">
                <div className="resumen-categoria__subitem">
                    <Icon name='dot' width={14} height={14} color='#D4C1FF ' />
                    <span className="resumen-categoria__subitem__text">
                        Bebidas
                    </span>
                </div>
                <span className='resumen-categoria__subitem__amount'>{formatCurrencyToFixed(ventas?.bebidas || 0)}</span>
            </div>
            <div className="resumen-categoria__item">
                <div className="resumen-categoria__subitem">
                    <Icon name='dot' width={14} height={14} color='#DBF6D4' />
                    <span className="resumen-categoria__subitem__text">
                        Sex & spa
                    </span>
                </div>
                <span className='resumen-categoria__subitem__amount'>{formatCurrencyToFixed(ventas?.['sex & spa'] || 0)}</span>
            </div>
            <div className="resumen-categoria__item">
                <div className="resumen-categoria__subitem">
                    <Icon name='dot' width={14} height={14} color='#FFE99C' />
                    <span className="resumen-categoria__subitem__text">
                        Otros
                    </span>
                </div>
                <span className='resumen-categoria__subitem__amount'>{formatCurrencyToFixed(ventas?.otros || 0)}</span>
            </div>
        </div>
    )
}

export default ResumenCategoria